import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {PermissionsTag} from "../../../../shared/interface/permissions-tag";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {takeUntil} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {HttpErrorResponse} from "@angular/common/http";
import {PermissionTagsService} from "../../../../shared/services/permission-tags.service";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {AddPermissionTagUserComponent} from "../add-permission-tag-user/add-permission-tag-user.component";

@Component({
  selector: 'app-permission-tags-details',
  templateUrl: './permission-tags-details.component.html',
  styleUrls: ['./permission-tags-details.component.scss']
})
export class PermissionTagsDetailsComponent implements OnInit, OnDestroy {

  @Output() permissionTagChanged = new EventEmitter<any>();

  permissionTagId: number;
  permissionTagObject?: PermissionsTag;
  permissionsTag: ReplaySubject<PermissionsTag> = new ReplaySubject<PermissionsTag>(1);
  modify = false;
  selectedTab: number;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(    private route: ActivatedRoute,
                  private permissionTagsService: PermissionTagsService,
                  private snack: MatSnackBar,
                  private dialog: MatDialog,
                  private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.permissionTagId = params.id;
        this.selectedTab = 0;
        this.loadPermissionTag();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadPermissionTag(): void {
    this.permissionTagsService.reloadDict(this.permissionTagId).subscribe((permissionsTag: PermissionsTag) => {
      this.permissionsTag.next(permissionsTag);
      this.permissionTagObject = permissionsTag;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych','', {
        duration: 2000
      });
    });
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.index === 2) {
      this.loadPermissionTag();
    }
  }

  add(): void {
    const dialogRef = this.dialog.open(AddPermissionTagUserComponent, {
      width: '700px',
      data: {permissionTag: this.permissionTagObject.id},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.permissionTagChanged.emit();
    });
  }
}
